import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Set target to end of current day
    const target = new Date();
    target.setHours(23, 59, 59, 999);
    const timer = setInterval(() => {
      const now = new Date();
      const difference = target.getTime() - now.getTime();
      if (difference <= 0) {
        target.setDate(target.getDate() + 1);
      } else {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-3 md:gap-6 justify-center items-center my-8" data-id="element-3">
      <div className="flex flex-col items-center" data-id="element-4">
        <div className="bg-primary-accent text-white text-3xl md:text-5xl font-bold rounded-xl w-16 h-16 md:w-24 md:h-24 flex items-center justify-center shadow-lg border-b-4 border-primary-hover" data-id="element-5">
          {timeLeft.hours.toString().padStart(2, '0')}
        </div>
        <span className="text-xs md:text-sm font-bold mt-3 text-text-light uppercase tracking-widest" data-id="element-6">
          Horas
        </span>
      </div>
      <span className="text-3xl md:text-5xl font-bold text-primary-accent -mt-8" data-id="element-7">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-8">
        <div className="bg-primary-accent text-white text-3xl md:text-5xl font-bold rounded-xl w-16 h-16 md:w-24 md:h-24 flex items-center justify-center shadow-lg border-b-4 border-primary-hover" data-id="element-9">
          {timeLeft.minutes.toString().padStart(2, '0')}
        </div>
        <span className="text-xs md:text-sm font-bold mt-3 text-text-light uppercase tracking-widest" data-id="element-10">
          Minutos
        </span>
      </div>
      <span className="text-3xl md:text-5xl font-bold text-primary-accent -mt-8" data-id="element-11">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-12">
        <div className="bg-primary-accent text-white text-3xl md:text-5xl font-bold rounded-xl w-16 h-16 md:w-24 md:h-24 flex items-center justify-center shadow-lg border-b-4 border-primary-hover" data-id="element-13">
          {timeLeft.seconds.toString().padStart(2, '0')}
        </div>
        <span className="text-xs md:text-sm font-bold mt-3 text-text-light uppercase tracking-widest" data-id="element-14">
          Segundos
        </span>
      </div>
    </div>;
}